import _ from "lodash";

export const SPORT_LIST_REQUEST = 'SPORT_LIST_REQUEST';
export const SPORT_LIST_SUCCESS = 'SPORT_LIST_SUCCESS';
var initialState = {
    byId: [],
    allIds: [],
    loading: false
};

export default (state = initialState, action) => {
    if (action.payload?.entities?.sport) {
        state = {
            ...state,
            byId: _.merge(state.byId, action.payload.entities.sport)
        }
    }
    switch (action.type) {
        case SPORT_LIST_REQUEST: {
            return {
                ...state,
                loading: true
            }
        }
        case SPORT_LIST_SUCCESS:
            return {
                ...state,
                allIds: action.payload.result,
                loading: false
            }
        default:
            return state;
    }
};